import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IFootballMatchTeams } from "../../../../../../commons/models/football/interface/i-football-match";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { FootballMatchTeams } from "../../../../../../commons/models/football/football-match-teams";
import { manageFootballSeasonService } from "../../../../../../commons";

export interface IManageMatchTeamsOption {
  seasonId: number;
  matchId: number;
  urlParams?: {
    hostTeamId?: number;
  };
}

export interface IFootballManageMatchTeamsState {
  manageMatchTeams: IFootballMatchTeams;
  manageMatchTeamsStatus: StatusEnum;
}

const initialState: IFootballManageMatchTeamsState = {
  manageMatchTeams: new FootballMatchTeams(),
  manageMatchTeamsStatus: StatusEnum.Idle,
};

export const fetchManageMatchTeams = createAsyncThunk(
  "manageMatchTeams/fetchManageMatchTeams",
  async (options: IManageMatchTeamsOption, thunkAPI) => {
    try {
      const manageMatchTeams = await manageFootballSeasonService.getSeasonMatchTeams(
        options.seasonId,
        options.matchId,
        options.urlParams
      );
      return manageMatchTeams;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageMatchTeamsSlice = createSlice({
  name: "footballManageMatchTeams",
  initialState: initialState,
  reducers: {
    cleanUpMatchTeam(state) {
      state.manageMatchTeams = new FootballMatchTeams();
      state.manageMatchTeamsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageMatchTeams.pending, (state) => {
        state.manageMatchTeamsStatus = StatusEnum.Loading;
      })
      .addCase(fetchManageMatchTeams.fulfilled, (state, action: PayloadAction<FootballMatchTeams>) => {
        state.manageMatchTeamsStatus = StatusEnum.Succeeded;
        state.manageMatchTeams = action.payload;
      })
      .addCase(fetchManageMatchTeams.rejected, (state) => {
        state.manageMatchTeamsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpMatchTeam } = footballManageMatchTeamsSlice.actions;
export default footballManageMatchTeamsSlice.reducer;
